import { initExerciseShow, initIframeResize } from "exercise.ts";

window.dodona.initExerciseShow = initExerciseShow;
window.dodona.initIframeResize = initIframeResize;
